import { render, staticRenderFns } from "./EntryDialog.vue?vue&type=template&id=9620e04e&scoped=true&"
import script from "./EntryDialog.vue?vue&type=script&lang=js&"
export * from "./EntryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9620e04e",
  null
  
)

export default component.exports